// ---------------------------------------------------------------------------
// Strike helpers — where a crater aims, and how many shots rockets stopped
// ---------------------------------------------------------------------------
//
// Lifted out of useGameState so the rules run without React. Both are pure.

import { fromPlotSub, plotSubIndices } from './subplotGrid.js'

// Deterministic aim subplot for a crater. The attacker picks the exact subplot
// (targetSub); games persisted before subplot targeting only carry the plot row,
// which aims at that plot's centre subplot. A defender's retaliation (no chosen
// target) picks a live subplot in the corridor column via a seed both clients
// share.
export function aimSubplot(homefront, col, targetRow, targetSub, seed) {
    if (targetSub != null) return targetSub
    if (targetRow != null) return fromPlotSub(col, targetRow, 1, 1)
    // Retaliation: pick a live subplot somewhere in this corridor column.
    const colCells = []
    for (let row = 0; row < 5; row++) colCells.push(...plotSubIndices(col, row))
    const live = colCells.filter(s => homefront?.subplots?.[s] && !homefront.subplots[s].destroyed)
    const pool = live.length > 0 ? live : colCells
    // xorshift scramble so adjacent seeds don't map to adjacent cells.
    let h = seed >>> 0
    h = ((h ^ (h >>> 15)) * 0x2c1b3c6d) >>> 0
    h = ((h ^ (h >>> 12)) * 0x297a2d39) >>> 0
    h = (h ^ (h >>> 15)) >>> 0
    return pool[h % pool.length]
}

// How many surplus-missile interceptions the animation should play: one per
// rocket that fired (each cancels a whole shot). A full wash stops every shot;
// otherwise rocketsFired is already < margin, so a missile still lands and the
// strike still shows.
export function interceptedShots(margin, rocketsFired, washed) {
    return washed ? margin : Math.min(margin, rocketsFired || 0)
}
